import React from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
}

export default function Toast({ message, type, onClose }: ToastProps) {
  const { theme } = useTheme();

  const icons = {
    success: <CheckCircle className="h-5 w-5 text-green-500" />,
    error: <AlertCircle className="h-5 w-5 text-red-500" />,
    info: <Info className="h-5 w-5 text-blue-500" />
  };

  const backgrounds = {
    success: theme === 'dark' ? 'bg-green-900/20' : 'bg-green-50',
    error: theme === 'dark' ? 'bg-red-900/20' : 'bg-red-50',
    info: theme === 'dark' ? 'bg-blue-900/20' : 'bg-blue-50'
  };

  return (
    <div className={`
      flex items-center space-x-3 p-4 rounded-lg shadow-lg
      ${backgrounds[type]}
      ${theme === 'dark' ? 'text-gray-100' : 'text-gray-900'}
    `}>
      {icons[type]}
      <p className="flex-1">{message}</p>
      <button
        onClick={onClose}
        className={`p-1 rounded-full transition-colors ${
          theme === 'dark'
            ? 'hover:bg-gray-700'
            : 'hover:bg-gray-200'
        }`}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}